/**
 * Servicio: citas
 * Endpoint: /wscita
 */

import { sendRequest } from '../../config';

export interface updateAppointmentParams {
    /** parametros obligatorios */
    ccita: string;
    ccedasegurado: string;

    /** parametros opcionales */
    iestado?: string;
}

export interface dataUpdateAppointment {
    description: string;
}

export const updateAppointment = async (params: updateAppointmentParams[]): Promise<dataUpdateAppointment> => {
    const ENDPOINT = 'wscita/update';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};